import { Component, Input, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ActionItem } from '../cpq-datatable/action-menu/action-links.model';

@Component({
    selector: 'cpq-button-menu',
    templateUrl: './cpq-button-menu.component.html',
    styleUrls: ['./cpq-button-menu.component.scss'],
    standalone: false
})
export class CpqButtonMenuComponent {
  @Input() public btnStyleClass: {[key: string]: boolean} | string = "";
  @Input() public iconStyleClass = "";
  @Input() public title = "";
  @Input() buttonText: string;
  @Input() isDisabled: boolean;
  @Input() items: Array<ActionItem> = [];
  @Input() data: any;
  @Input() id: string;
  @ViewChild(MatMenuTrigger, { static: true }) menuTrigger: MatMenuTrigger;

  expanded = false;
  constructor() { }

  select(item) {
    setTimeout(() => {
      item.click(this.data)
    }, 30);
  }

  public checkIfItemIsVisible(item) {
    return item.visible ? item.visible(this.data) : true;
  }
}
